import React from 'react';
import PropTypes from 'prop-types';
import { TimePicker } from 'antd';
import './WorkingHoursTimePickerComponent.scss';

function WorkingHoursTimePicker(props) {
  const { valueText, configTime, getFieldDecorator } = props;
  return (
    <div className="working-hours-time-picker">
      {getFieldDecorator(valueText, configTime)(<TimePicker use12Hours format="h:mma" className="hours-time-picker" />)}
    </div>
  );
}

export default WorkingHoursTimePicker;

WorkingHoursTimePicker.propTypes = {
  valueText: PropTypes.string.isRequired,
  configTime: PropTypes.shape({}).isRequired,
  getFieldDecorator: PropTypes.func.isRequired,
};
